import React, { useEffect, useState } from 'react';
import { useMainContext } from "../../../contexts/MainContext";
import { RestActions } from "../../../actions";

//COMPONENTS
import HeaderDemand from '../../../components/atoms/headerDemand';
import MenuDemandImporter from '../../../components/molecules/MenuDemandImporter';
import TableTemplates from './TableTemplates';
import SearchTemplatesFilters from './SearchTemplatesFilters';

import '../../../styles.css';

const Templates = ({ preloadReady }) => {
	const rest = new RestActions();
	const [datademandImporter, setDatademandImporter] = useState({});
	let mainContext = useMainContext();
	const [dataTable, setDataTable] = useState({});
	const [pageLimit, setPageLimit] = useState(10);
		const [currentFilters, setCurrentFilters] = useState({});

	useEffect(() => {
		if (preloadReady) {
			initTable()
		}

	}, [preloadReady, currentFilters])

	const initTable = async () => {
		mainContext.setIsLoading(true);
		try {
			// let response = await rest.post("getUsers", {
			// 	pageLimit: pageLimit, pageNumber: _pageNumber
			// });
			// setDataTable(response);
			mainContext.setIsLoading(false);

		}
		catch (error) {/*TODO SOMETHING*/ }
	}
	return (
		<section>
			<HeaderDemand />
			<MenuDemandImporter linkActive={"templates"} />
			<div className="custom-card contentTable">
				<div className="custom-card-header px-3 d-flex">
					<h4 className="py-3 w-50">PLANTILLAS</h4>
				</div>
				<div className="">
					<div className="table-scroll-y table-scroll-y-scrollable">
						<div className="table-responsive h-100">
							<SearchTemplatesFilters handlerFilters={setCurrentFilters} />
							<TableTemplates handleRefresh={initTable} data={dataTable} />
						</div>
					</div>
				</div>
			</div>
		</section>

	)
}

export default Templates;
